// extracted by mini-css-extract-plugin
module.exports = {"div":"Sect4_Comp1_div__2QMxn","mobile":"Sect4_Comp1_mobile__2PtY8","desktop":"Sect4_Comp1_desktop__3fBta"};